var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVr360(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".VR_360_svg__cls-2{fill:#e8eaeb;stroke:#1a2e3b;stroke-miterlimit:10;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VR_360_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VR_360_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0a30 30 0 1030 30A30 30 0 0030 0",
    fill: "#e8eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    className: "VR_360_svg__cls-2",
    d: "M45 20.48H15v19h8.44a2.23 2.23 0 001.93-1.11l1.95-3.31a2.32 2.32 0 012-1.15h1.33a2.32 2.32 0 012 1.15l2 3.35a2.23 2.23 0 001.93 1.11H45z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "VR_360_svg__cls-2",
    cx: 22.56,
    cy: 27.76,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "VR_360_svg__cls-2",
    cx: 37.44,
    cy: 27.76,
    r: 3
  })))));
}
export default SvgVr360;